import React, { useEffect, useState } from 'react';
import PageHelmet from '../Helper/PageHelmet';
import { useLocation } from 'react-router-dom';
// import Header from '../Helper/Header';
import Footer from '../Helper/Footer';

import LoginPage from './LoginPage';
import ListBlogs from './ListBlogs';
import ListNews from './ListNews';

const Home = () => {
    const [IsLogin, SetIsLogin] = useState(false);
    const [Page, SetPage] = useState('listBlog');
    const location = useLocation();

    useEffect(() => {
        const cssFile = document.createElement('link');
        cssFile.rel = 'stylesheet';
        cssFile.href = '/assets/admin.css'; // Adjust the path if necessary
        document.head.appendChild(cssFile);
        // SetIsLogin(false);
        return () => {
            document.head.removeChild(cssFile);
        };
    }, [location]);
    return (
        <>
            <PageHelmet pageTitle="Home" />
            {/* <Header /> */}
            <div className='container mt-3'>
                <div className="main-menu">
                    <nav id="mobile-menu">
                        <ul>
                            <li>
                                <a
                                    className=""
                                    href="/administrator/blog"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        SetPage('listBlog')
                                    }}
                                >
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a
                                    className=""
                                    href="/administrator/news"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        SetPage('listNews')
                                    }}
                                >
                                    NEWS
                                </a>
                            </li>
                            <li className='pull-right'>
                                <a className="" href="/" style={{ float: 'right' }}>
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            {!IsLogin && <LoginPage SetIsLogin={SetIsLogin} />}
            {IsLogin && Page === "listBlog" && <ListBlogs />}
            {IsLogin && Page === "listNews" && <ListNews />}
            <Footer />
        </>
    );
};

export default Home;